import React, { useState } from "react";
import bulletin4 from "../assets/newletter/ccl.jpeg";
import bulletin1 from "../assets/newletter/Mangalore-Port-Bulletin.jpg";
import bulletin2 from "../assets/newletter/NTPC-LARA-Bulletin.jpg";
import "../styles/newsletterStyles.css";

const bulletins = [
  { src: bulletin4, title: "Central Coalfields Limited " },
  { src: bulletin1, title: "Manglore Port" },
  { src: bulletin2, title: "NTPC Lara" },
];

const Newsletter = () => {
  const [fullscreenImage, setFullscreenImage] = useState(null);

  const handleImageClick = (src) => {
    setFullscreenImage(src);
  };

  const closeFullscreen = () => {
    setFullscreenImage(null);
  };

  return (
    <>
      <div className="container text-center my-5">
        <div className="row">
          {bulletins.map((bulletin, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
              <div
                className="card h-100"
                style={{ backgroundColor: "transparent" }}
              >
                <img
                  src={bulletin.src}
                  className="card-img-top img-fluid"
                  alt={`Certificate ${index + 1}`}
                  onClick={() => handleImageClick(bulletin.src)}
                  style={{ cursor: "pointer", border: "2px solid black" }}
                />
                <div className="card-body">
                  <p className="card-title fw-bold" style={{ color: "black" }}>
                    {bulletin.title}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {fullscreenImage && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-75"
          onClick={closeFullscreen}
          style={{ zIndex: 1050 }}
        >
          <img
            src={fullscreenImage}
            alt="Fullscreen"
            className="img-fluid"
            style={{ maxWidth: "90%", maxHeight: "90%" }}
          />
        </div>
      )}
    </>
  );
};

export default Newsletter;
